<!--登录页面-->
<template>
  <div class="loginBox">
    <div class="Login">
      <div style="width: 528px; margin: 0 auto; border-radius: 10px;overflow: hidden">
        <div class="Login-top">院校管理后台</div>
        <div class="login-bottom">
          <div>
            <el-input
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              v-model="loginFrom.username"
              @keyup.enter.native="keyDown"
            >
            </el-input>
          </div>
          <div style="margin-top:30px">
            <el-input
              placeholder="请输入密码"
              prefix-icon="el-icon-lollipop"
              type="password"
              @keyup.enter.native="keyDown"
              v-model="loginFrom.password"
            >
            </el-input>
          </div>
          <!-- <div style="margin-top:30px">
            <el-checkbox v-model="checked">记住用户名和密码</el-checkbox>
          </div> -->
          <div style="margin-top:30px">
            <el-button class="formBtn" type="success" @click="Loginevent"
            >登录
            </el-button
            >
          </div>
          <div style="margin-top: 10px;text-align: right;font-size: 14px">
            <a href="http://www.vstrain.cn/"
               style="color: #adafae;">小火车平台登录</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Login } from '../assets/js/network/network';

export default {
  name: 'Login',
  data() {
    return {
      // 登录表单数据
      loginFrom: {
        username: '',
        password: '',
      },
      // 是否记住登录状态
      checked: false,
    };
  },
  mounted() {
    if(localStorage.getItem('token')){
      this.$router.push('/accountManagement');
    }
  },
  methods: {
    keyDown(){
      this.Loginevent()
    },
    // 登录
    Loginevent() {
      // 登录前判断 用户名和密码不能为空
      if (this.loginFrom.username == '' || this.loginFrom.password == '') {
        this.$message({
          message: '账号密码不能为空',
          type: 'warning',
        });
        return;
      }
      var reg=/\\|\/|\?|\？|\*|\"|\“|\”|\'|\‘|\’|\<|\>|\{|\}|\[|\]|\【|\】|\#|\&|\：|\:|\、|\^|\$|\!|\~|\`|\|/g;
      this.loginFrom.username = this.loginFrom.username.replace(reg,"");
      // 把密码拿出来，做加密
      let  userpasswodr = this.loginFrom.password;
      // 发送给后台的数据账号、密码
      let data = {
        account: this.loginFrom.username,
        password: this.$md5(userpasswodr)
      };
      Login(data)
        .then((res) => {
          // 如果请求成功把token单独存在本地localStorage中，把所有数据存在localStorage中
          if (res.code === 0) {
            localStorage.setItem('token', res.ret.token);
            localStorage.setItem('session', JSON.stringify(res.ret));
            localStorage.setItem('pass',data.password)
            this.$router.push('/accountManagement');
            this.$message({
              message: '登录成功',
              type: 'success'
            });
          }

        });
    }
  },


};
</script>

<style scoped>
@import "../style/common.css";
.loginBox {
  height: 100vh;
  background: url("../assets/images/logo_bg_proc.jpg");
  background-size:cover;
}

.Login {
  width: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.Login-top {
  padding: 20px 30px;
  background: url("../assets/images/login_name_bg.jpg");
  color: #fff;
  font-size: 30px;
  font-weight: bold;
}

.login-bottom {
  padding: 42px;
  box-sizing: border-box;
  height: 340px;
  background: #fff;
}

/* .login-img {
  width: 100%;
  height: 45px;
  background: url("../assets/images/login_name_bg.jpg");
}

.login-img span {
 font-size:25px;
 color:#fff;
 line-height: 45px;
 padding-left: 30px;
}

.login-top {
  font-size: 18px;
  font-weight: 600;
  color: royalblue;
  text-align: center;
}

.login-top p {
  width: 100%;
  height: 2px;
  background-color: royalblue;
  margin: 10px 0 20px 0;
} */

.formBtn {
  height: 50px;
  width: 100%;
}
</style>
